import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";

import klerData from "../../apis/klerData";

class UserEdit extends React.Component {
  render() {
    const updateRecord = formValues => {
      let updatedata = "";
      updatedata += "{";
      updatedata += `Email: "${formValues.Email}",`;
      updatedata += `SubscriptionId@odata.bind: "Subscription(${formValues.SubscriptionId})",`;
      if (formValues.Admin) {
        updatedata += `Admin: true`;
      } else {
        updatedata += `Admin: false`;
      }
      updatedata += "}";
      //console.log(updatedata);
      if (formValues.Oid) {
        // **************************
        // UPDATE RECORD
        klerData
          .put(`/UserAccess(${parseInt(formValues.Oid)})`, updatedata)
          .then(result => {
            this.props.handleCloseReload();
          })
          .catch(error => console.log(error));
      } else {
        // **************************
        // CREATE RECORD
        klerData
          .post(`/UserAccess`, updatedata)
          .then(result => {
            this.props.handleCloseReload();
          })
          .catch(error => console.log(error));
      }
    };
    const onSubmit = formValues => {
      // console.log(formValues);
      updateRecord(formValues);
    };
    return (
      <div className="txt-center">
        <h4>User</h4>
        <form onSubmit={this.props.handleSubmit(onSubmit)}>
          <div>
            <Field
              name="Oid"
              component="input"
              type="hidden"
              autoComplete="off"
            />
            <Field
              name="SubscriptionId"
              component="input"
              type="hidden"
              autoComplete="off"
            />
          </div>
          <div>
            <label>Email</label>
            <div>
              <Field
                name="Email"
                component="input"
                type="text"
                placeholder="Email"
                autoComplete="off"
              />
            </div>
          </div>
          <div>
            <label htmlFor="employed">Administrator</label>
            <div>
              <Field
                name="Admin"
                component="input"
                type="checkbox"
                placeholder="Admin"
              />
            </div>
          </div>
          <button className="waves-effect waves-light btn btn-small">
            Submit
          </button>
          &nbsp;
          <button
            type="button"
            className="waves-effect waves-light btn btn-small"
            onClick={this.props.handleClose}
          >
            Cancel
          </button>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  // **************************
  // FIX REFERENCE LINK FIELDS
  let initVals = [];
  if (ownProps.data.Admin) {
    initVals.Admin = "true";
  } else {
    initVals.Admin = "false";
  }

  return {
    initialValues: {
      Oid: ownProps.data.Oid,
      Email: ownProps.data.Email,
      Admin: ownProps.data.Admin,
      SubscriptionId: ownProps.subscriptionId
    }
  };
};

const validate = formValues => {
  const errors = {};

  if (!formValues.Email) {
    errors.Email = "Please enter a name";
  }

  return errors;
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "UserEdit",
    validate
  })(UserEdit)
);
